import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertsActiveService {
  private alertsActive = new BehaviorSubject<boolean>(false);

  setAlertsActive(isActive: boolean): void {
    this.alertsActive.next(isActive);
  }

  getAlertsActive() {
    return this.alertsActive.asObservable();
  }

  isAlertsActive(): boolean {
    return this.alertsActive.value;
  }
}
